import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
// import {
//   NbAccordionModule, NbAlertModule,
//   NbButtonModule,
//   NbCardModule,
//   NbDatepickerModule,
//   NbIconModule, NbInputModule, NbListModule, NbRadioModule,
//   NbRouteTabsetModule, NbSelectModule, NbStepperModule,
//   NbTabsetModule, NbToggleModule, NbTooltipModule, NbUserModule
// } from '@nebular/theme';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { NgxPermissionsModule } from 'ngx-permissions';
import { FooterComponent } from './components/footer/footer.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { DigitalStampComponent } from './components/digital-stamp/digital-stamp.component';
import { MainNavComponent } from './components/main-nav/main-nav.component';
import { SearchComponent } from './components/search/search.component';
import { FavouriteButtonComponent } from './components/favourite-button/favourite-button.component';
import { OurTeamComponent } from './components/our-team/our-team.component';
import { TextInputComponent } from './components/text-input/text-input.component';
import { TextAreaComponent } from './components/text-area/text-area.component';
import { SelectInputComponent } from './components/select-input/select-input.component';
import { FileInputComponent } from './components/file-input/file-input.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { LabelInputComponent } from './components/label-input/label-input.component';
import { CamelCasePipe } from './pipes/camel-case.pipe';
import { Enum2ArrayPipe } from './pipes/enum2array.pipe';
import { NumbersOnlyDirective } from './directives/numbers-only.directive';
import { ExternalLinkDirective } from './directives/external-link.directive';
import { TextListInputComponent } from './components/text-list-input/text-list-input.component';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { LocalizedDatePipe } from './pipes/localized-date.pipe';
import { CustomCarouselComponent } from './components/custom-carousel/custom-carousel.component';
import { CustomProgressComponent } from './components/custom-progress/custom-progress.component';
import { CustomLoaderComponent } from './components/custom-loader/custom-loader.component';
import { AlertComponent } from './components/alert/alert.component';
import { VideoPlayerComponent } from './components/video-player/video-player.component';
import { NgChartsModule } from 'ng2-charts';
import { AudioPlayerComponent } from './components/audio-player/audio-player.component';
import { JobDetailsComponent } from './components/job-details/job-details.component';
import { AvatarComponent } from './components/avatar/avatar.component';
import { NotFoundStateComponent } from './components/not-found-state/not-found-state.component';
import { TablistDirective } from './directives/tablist.directive';

const Components = [
  CustomLoaderComponent,
  BreadcrumbComponent,
  DigitalStampComponent,
  FooterComponent,
  MainNavComponent,
  SearchComponent,
  FavouriteButtonComponent,
  TextInputComponent,
  TextAreaComponent,
  SelectInputComponent,
  FileInputComponent,
  LabelInputComponent,
  TextListInputComponent,
  CustomCarouselComponent,
  CustomProgressComponent,
  AlertComponent,
  VideoPlayerComponent,
  AudioPlayerComponent,
  JobDetailsComponent,
  AvatarComponent,
  NotFoundStateComponent
];
const nbModules = [NgbModule, TranslateModule];
// LocalizedDatePipe is named `date`: it overrides CommonModule's DatePipe wherever SharedModule is imported after it.
const pipes = [CamelCasePipe, Enum2ArrayPipe, SafeHtmlPipe, LocalizedDatePipe];
const directives = [NumbersOnlyDirective, ExternalLinkDirective, TablistDirective];
@NgModule({
  declarations: [...Components, OurTeamComponent, NotFoundComponent,
    ErrorPageComponent,
    ...pipes,
    ...directives,
    CustomCarouselComponent,
    CustomProgressComponent,
  ],
  imports: [
    CommonModule,
    ...nbModules,
    FormsModule,
    RouterModule,
    NgChartsModule,
    NgxPermissionsModule
  ],
  exports: [...Components, FormsModule, ...nbModules, ...pipes, ...directives],
})
export class SharedModule { }
